
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/p/[slug]",
      function () {
        return require("private-next-pages/products/p/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/p/[slug]"])
      });
    }
  